import React from 'react';
import { Button } from 'react-bootstrap';
import Multiselect from 'multiselect-react-dropdown';
import FormLabel from '../../../components/FormLabel/FormLabel';

// filterGroup.values now holds an array of objects: [{ name, value }]
function FilterGroup({ filterGroup, index, isBusy, onValuesChange, onRemove }) {
    const selectedValueIds = (filterGroup.values || []).map(v => (typeof v === 'object' ? v.value : v));
    return (
        <div style={{
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '15px',
            marginBottom: '15px',
            backgroundColor: '#f9f9f9'
        }}>
            <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px' }}>
                <div style={{ flex: 1 }}>
                    <FormLabel>{filterGroup.config.label}</FormLabel>
                    <Multiselect
                        options={filterGroup.config.options}
                        selectedValues={filterGroup.config.options.filter(opt =>
                            selectedValueIds.includes(opt.id))}
                        displayValue="name"
                        disabled={isBusy}
                        placeholder={`Select ${filterGroup.config.label}...`}
                        emptyRecordMsg={`No ${filterGroup.config.label} Available`}
                        onSelect={(selectedList) => onValuesChange(index, selectedList)}
                        onRemove={(selectedList) => onValuesChange(index, selectedList)}
                        style={{
                            multiselectContainer: {
                                maxHeight: '120px'
                            }
                        }}
                    />
                </div>
                <div>
                    <Button
                        bsStyle="danger"
                        disabled={isBusy}
                        onClick={() => onRemove(index)}
                    >
                        <i className="fa fa-trash"></i>
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default FilterGroup;